import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "PublisherManagement",
  components: { Loading },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      loader: "bars",
      publisherList: [],
      singlePublisherList: {},
      name: "",
      en_name: "",
      email: "",
      phone: "",
      password: "",
      address: "",
      files: null,
    };
  },
  async created() {
    await this.getAll();
  },
  methods: {
    async getAll() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/publishers/publisherslist",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        //console.log(res)
        if (res.status === 200) {
          this.publisherList = res.data;
          this.isLoading = false;
          console.log(this.publisherList)
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async getSingle(id) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/publishers/get-publishers-byID?id=" +
            id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status === 200) {
          console.log(res.data)
          this.singlePublisherList = res.data;
          this.isLoading = false;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    onImageChange(event) {
      this.files = event.target.files[0];
    },
    async addPublisher() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const formData = new FormData();
        formData.append("full_name", this.name);
        formData.append("en_name", this.en_name);
        formData.append("email", this.email);
        formData.append("password", this.password);
        formData.append("phone", this.phone);
        formData.append("address", this.address);
        formData.append("files", this.files);
        const res = await axios.post(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/auth/signup-book-publisher",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.isLoading = false;
        if (res.status === 201 || res.status === 200) {
          this.isLoading = false;
          document.getElementById("add_btn_close").click();
          this.$swal.fire({
            icon: "success",
            title: "create Publisher successfully",
          });
          await this.getAll();
        } else {
          this.isLoading = false;
          this.$vToastify.error("Could not create Cast and crew");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          text: "An error occurred!",
        });
      }
    },
    async update(e) {
      this.isLoading = true;
      if (
        this.files === undefined ||
        this.files === "" ||
        this.files === null
      ) {
        await this.updateWithoutImage(e);
      } else {
        await this.updateWithImage(e);
      }
    },
    async updateWithImage(e) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const formData = new FormData();
        formData.append("id", this.singlePublisherList.id);
        formData.append("full_name", this.singlePublisherList.full_name);
        formData.append("en_name", this.singlePublisherList.en_name);
        formData.append("email", this.singlePublisherList.email);
        formData.append("phone", this.singlePublisherList.phone);
        formData.append("address", this.singlePublisherList.address);
        formData.append("files", this.files);
        const res = await axios.post(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/publishers/update-publishers",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.isLoading = false;
        if (res.status === 201 || res.status === 200) {
          this.isLoading = false;
          document.getElementById("edit_btn_close").click();
          this.$swal.fire({
            icon: "success",
            title: "Publisher Update successfully",
          });
          this.files = null;
          e.target.reset();
          await this.getAll();
        } else {
          this.isLoading = false;
          this.$vToastify.error("Something went wrong");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          text: "An error occurred!",
        });
      }
    },
    async updateWithoutImage(e) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        let data = {
          id: this.singlePublisherList.id,
          full_name: this.singlePublisherList.full_name,
          en_name: this.singlePublisherList.en_name,
          email: this.singlePublisherList.email,
          address: this.singlePublisherList.address,
          imageUrl: this.singlePublisherList.imageUrl,
          phone: this.singlePublisherList.phone,
        };
        const res = await axios.post(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/publishers/update-publishers",
          JSON.stringify(data),
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status === 201 || res.status === 200) {
          this.isLoading = false;
          document.getElementById("edit_btn_close").click();
          this.$swal.fire({
            icon: "success",
            title: "Publisher Update successfully",
          });
          this.files = null;
          e.target.reset();
          await this.getAll();
        } else {
          this.isLoading = false;
          this.$vToastify.error("Something went wrong");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          text: "An error occurred!",
        });
      }
    },
    closeModal: function () {
      this.name = "";
      this.en_name = "";
      this.email = "";
      this.phone = "";
      this.password = "";
      this.address = "";
      this.files = null;
    },
  },
};
